import { Typography } from '@cleartrip/ct-design-components'
import React from 'react'

type VisaRejectionFilterLabelProps = {
  variant?: 'P2' | 'B3'
  className?: string
}

const VisaRejectionFilterLabel: React.FC<VisaRejectionFilterLabelProps> = ({
  variant = 'P2',
  className = '',
}) => (
  <Typography className={className} variant={variant}>
    Has{' '}
    <Typography as='span' className='fw-700' color='success' variant={variant}>
      FREE
    </Typography>{' '}
    Visa Rejection Cover
  </Typography>
)

export default VisaRejectionFilterLabel
